import { Directive, TemplateRef, inject } from '@angular/core';

/** Contexto de la plantilla de ítem de `sc-select`: el ítem como `$implicit`. */
export interface ScSelectItemContext {
  $implicit: any;
}

/**
 * Plantilla de cada opción de `sc-select` (reemplaza a `*dxTemplate … of 'item'`):
 * `<ng-template scSelectItem let-item>…</ng-template>`.
 */
@Directive({ selector: 'ng-template[scSelectItem]' })
export class ScSelectItemDirective {
  readonly template = inject<TemplateRef<ScSelectItemContext>>(TemplateRef);

  static ngTemplateContextGuard(
    _directive: ScSelectItemDirective,
    context: unknown,
  ): context is ScSelectItemContext {
    return true;
  }
}
